export default __webpack_public_path__ + "static/media/blueLineHamburger.00c9ee2a.svg";